<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-6">Point of Sale</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="item in navItems"
        :key="item.route"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card
          class="nav-card"
          hover
          @click="navigateTo(item.route)"
          height="120"
        >
          <v-card-text class="d-flex flex-column align-center justify-center h-100">
            <v-icon
              :icon="item.icon"
              size="32"
              class="mb-2"
              color="primary"
            ></v-icon>
            <span class="text-center text-body-2">{{ item.name }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const navItems = [
  { name: 'appointments', icon: 'mdi-pencil-box', component: 'pos', route: 'appointments' },
  { name: 'Client Check In', icon: 'mdi-pencil-box', component: 'orders', route: 'client-checkin' },
  { name: 'Wait List', icon: 'mdi-pencil-box', component: 'orders', route: 'wait_list' },
  { name: 'Second screen', icon: 'mdi-file-document-multiple', component: '', route: 'appointment-second-screen' },
  { name: 'Daily Denomination', icon: 'mdi-file-document-multiple', component: '', route: 'daily-denomination' },
  { name: 'Sales Summary', icon: 'mdi-file-document-multiple', component: '', route: 'sales-summary' },
  { name: 'Cashout', icon: 'mdi-file-document-multiple', component: '', route: 'staff-checkout' },
  { name: 'Setup Terminal', icon: 'mdi-file-document-multiple', component: '', route: 'terminal-stripe' },
  { name: 'Settings', icon: 'mdi-cog', component: '', route: 'settings' },
  { name: 'Message', icon: 'mdi-file-document-multiple', component: 'message', route: 'messages' },
];

function navigateTo(route: string) {
  router.push({ name: route });
}
</script>

<style scoped>
.nav-card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.nav-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-card:active {
  transform: translateY(0);
}
</style>
